import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DateCompareService {
  constructor() { }

  checkAppDate: boolean = false;
  DateCompare(applicationdate: string, approvaldate: string): boolean {
    var day1: number = Number(applicationdate.slice(0, 2));
    var month1: number = Number(applicationdate.slice(3, 5));
    var year1: number = Number(applicationdate.slice(-4));

    var day2: number = Number(approvaldate.slice(0, 2))
    var month2: number = Number(approvaldate.slice(3, 5));
    var year2: number = Number(approvaldate.slice(-4));

    if (year1 === year2) {
      if (month1 === month2) {
        if (day1 === day2) {
          this.checkAppDate = false;
        }
        else if (day1 > day2) {
          this.checkAppDate = true;
        } else {
          this.checkAppDate = false;
        }
      }
      else if (month1 > month2) {
        this.checkAppDate = true;
      } else {
        this.checkAppDate = false;
      }
    }
    else if (year1 > year2) {
      this.checkAppDate = true;
    } else {
      this.checkAppDate = false;
    }

    return this.checkAppDate;
  }

  DateCompareReverse(applicationdate: string, approvaldate: string): boolean {
    var day1: number = Number(applicationdate.slice(0, 2));
    var month1: number = Number(applicationdate.slice(3, 5));
    var year1: number = Number(applicationdate.slice(-4));

    var day2: number = Number(approvaldate.slice(0, 2))
    var month2: number = Number(approvaldate.slice(3, 5));
    var year2: number = Number(approvaldate.slice(-4));

    if (year1 === year2) {
      if (month1 === month2) {
        if (day1 === day2) {
          this.checkAppDate = false;
        }
        else if (day1 < day2) {
          this.checkAppDate = true;
        } else {
          this.checkAppDate = false;
        }
      }
      else if (month1 < month2) {
        this.checkAppDate = true;
      } else {
        this.checkAppDate = false;
      }
    }
    else if (year1 < year2) {
      this.checkAppDate = true;
    } else {
      this.checkAppDate = false;
    }

    return this.checkAppDate;
  }


}
